
export default {

    getVisibleSymbolMoney(){
        let _val= window.localStorage.getItem(localStorageKeys.visibleSymbolMoney);
		if(_val==null)
			return true;
		return (_val.toLowerCase() == 'true');
	},
     
    setVisibleSymbolMoney(val){
		window.localStorage.setItem(localStorageKeys.visibleSymbolMoney,val);
	},

    getAskBeforeBondCreation(){
		let _val= window.localStorage.getItem(localStorageKeys.askBeforeBondCreation);
		if(_val==null)
			return true;
		return (_val.toLowerCase() == 'true');
    },
       
	setAskBeforeBondCreation(val){
		window.localStorage.setItem(localStorageKeys.askBeforeBondCreation,val);
	},

	getLocalFinancialFileId(){
		let _val = window.localStorage.getItem(localStorageKeys.localFinancialFileId);
		if(_val == "null" || _val == null)
			return null;
		return Number(_val);
    },
       
	setLocalFinancialFileId(val){
		window.localStorage.setItem(localStorageKeys.localFinancialFileId,val);
	},

	getLocalUser(){
		let _val = window.localStorage.getItem(localStorageKeys.localUser);
		if(_val == "null" || _val == null)
			return null;
		return JSON.parse(_val);
    },
       
	setLocalUser(val){
		window.localStorage.setItem(localStorageKeys.localUser,val);
	},
}


const localStorageKeys={
   visibleSymbolMoney:"visibleSymbolMoney",
   askBeforeBondCreation : "askBeforeBondCreation",
   localFinancialFileId : "localFinancialFileId",
   localUser: "localUser"
}